import Button from "@/common/elements/Button";
import CommonDatePicker from "@/common/elements/DatePicker";
import Select from "@/common/elements/InputElements/Select";
import Switch from "@/common/elements/InputElements/Switch";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import { useState } from "react";
import { Col } from "react-bootstrap";
import { getFlagIcon, INMATE_FLAG_TYPE } from "../InmateFlag";
import {
  DateTypeContainer,
  FlagBody,
  FlagFooter,
  FlagHeader,
  FlagSection,
} from "./styles";
import { v4 as uuidV4 } from "uuid";

const ManageFlagsModal = ({ show, onHide }) => {
  const [flagsEnabled, setFlagsEnabled] = useState({});
  const [flagDetails, setFlagDetails] = useState({});

  const onFlagsEnableChange = ({ target: { checked, name } }) => {
    setFlagsEnabled((prev) => ({ ...prev, [name]: checked }));
    // Initialize empty array for the flag type if enabled
    if (checked && !flagDetails[name]) {
      setFlagDetails((prev) => ({
        ...prev,
        [name]: [
          {
            id: uuidV4(),
            type: "",
            date: { startDate: null, endDate: null },
            description: "",
          },
        ],
      }));
    }
  };

  const onFlagDetailsChange = (flagType, flagId, key, value) => {
    setFlagDetails((prev) => ({
      ...prev,
      [flagType]: prev[flagType].map((flag) =>
        flag.id === flagId ? { ...flag, [key]: value } : flag
      ),
    }));
  };

  const addNewFlag = (flagType) => {
    setFlagDetails((prev) => ({
      ...prev,
      [flagType]: [
        ...prev[flagType],
        {
          id: uuidV4(),
          type: "",
          date: { startDate: null, endDate: null },
          description: "",
        },
      ],
    }));
  };

  const removeFlag = (flagType, flagId) => {
    setFlagDetails((prev) => ({
      ...prev,
      [flagType]: prev[flagType].filter((flag) => flag.id !== flagId),
    }));
  };

  const renderFlagInstances = (flagType) => {
    if (!flagDetails[flagType]) return null;

    return flagDetails[flagType].map((flag, index) => (
      <FlagBody key={flag.id}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <h6>Flag #{index + 1}</h6>
          {flagDetails[flagType].length > 1 && (
            <Button size="sm" onClick={() => removeFlag(flagType, flag.id)}>
              Remove Flag
            </Button>
          )}
        </div>
        <DateTypeContainer>
          <Col lg={4}>
            <Select
              placeholder="Type"
              options={[{ value: "", label: "" }]}
              value={flag.type || null}
              onChange={(value) =>
                onFlagDetailsChange(flagType, flag.id, "type", value)
              }
            />
          </Col>
          <Col lg>
            <CommonDatePicker
              value={[flag.date.startDate, flag.date.endDate]}
              onChange={(dates) =>
                onFlagDetailsChange(flagType, flag.id, "date", {
                  startDate: dates[0],
                  endDate: dates[1],
                })
              }
              showTime={false}
              range
            />
          </Col>
        </DateTypeContainer>
        <TextField
          id={`${flagType}Description${index}`}
          name={flagType}
          as="textarea"
          label="Flag Description"
          placeholder="Flag Description"
          value={flag.description}
          rows={5}
          onChange={(event) =>
            onFlagDetailsChange(
              flagType,
              flag.id,
              "description",
              event.target.value
            )
          }
        />
      </FlagBody>
    ));
  };

  const renderFlagSection = (flagType, label) => (
    <FlagSection>
      <FlagHeader className={flagType} enabled={flagsEnabled?.[flagType]}>
        <div>
          <img
            alt={`flag ${INMATE_FLAG_TYPE[flagType]} icon`}
            src={getFlagIcon(flagType)}
          />{" "}
          &nbsp;
          {label}
        </div>
        <Switch
          id={flagType}
          name={flagType}
          value={flagsEnabled?.[flagType]}
          onChange={onFlagsEnableChange}
        />
      </FlagHeader>
      {flagsEnabled?.[flagType] && (
        <>
          {renderFlagInstances(flagType)}
          <FlagFooter>
            <Button onClick={() => addNewFlag(flagType)}>
              Add Another {label} Flag
            </Button>
          </FlagFooter>
        </>
      )}
    </FlagSection>
  );

  const onSaveChanges = () => {
    // Implement save logic here
    console.log("Saving flags:", flagDetails);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      header="Manage Inmate Flags"
      footerActions={[
        {
          key: "save",
          text: "Save Changes",
          onClick: onSaveChanges,
        },
      ]}
    >
      <>
        {renderFlagSection(INMATE_FLAG_TYPE.WARRANT, "Warrant")}
        {renderFlagSection(INMATE_FLAG_TYPE.CIVIC, "Civic")}
        {renderFlagSection(INMATE_FLAG_TYPE.DANGER, "Dangerous")}
        {renderFlagSection(INMATE_FLAG_TYPE.INJAIL, "In Jail")}
        {renderFlagSection(INMATE_FLAG_TYPE.GANG, "Gang")}
        {renderFlagSection(INMATE_FLAG_TYPE.MEDICAL, "Medical")}
        {renderFlagSection(INMATE_FLAG_TYPE.NOTES, "Notes")}
      </>
    </Modal>
  );
};

export default ManageFlagsModal;
